import { BENTOBOX_SUBGRAPH_URL } from 'sushi/config/subgraph';
import { addChainId } from '../../../lib/modifiers/add-chain-id';
import { convertIdToMultichainId } from '../../../lib/modifiers/convert-id-to-multichain-id';
import { copyIdToAddress } from '../../../lib/modifiers/copy-id-to-address';
import {} from '../../../lib/request';
import { requestPaged } from '../../../lib/request-paged';
import { graphql } from '../graphql';
export const BentoBoxRebasesQuery = graphql(`
  query Rebases($first: Int = 1000, $skip: Int = 0, $block: Block_height, $orderBy: Rebase_orderBy, $orderDirection: OrderDirection, $where: Rebase_filter) {
    rebases(first: $first, skip: $skip, block: $block, orderBy: $orderBy, orderDirection: $orderDirection, where: $where) {
      id
      token {
        symbol
        name
        decimals
      }
      base
      elastic
      }
  }
`);
export async function getRebases({ chainId, ...variables }, options) {
    const url = `https://${BENTOBOX_SUBGRAPH_URL[chainId]}`;
    const result = await requestPaged({
        chainId,
        url,
        query: BentoBoxRebasesQuery,
        variables,
        options,
    });
    return result.rebases.map((rebase) => convertIdToMultichainId(copyIdToAddress(addChainId(chainId, rebase))));
}
